import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import styles from "./styles.module.scss";

const MaxWidthSlide = ({ className, ...props }) => (
  <div {...props} className={cn(styles.slide, className)} />
);

MaxWidthSlide.propTypes = { className: PropTypes.string };

MaxWidthSlide.defaultProps = { className: "" };

export default MaxWidthSlide;
